import AbModal from './abModal.vue'
import abModalFunc from './abmodal_func'

export default (Vue) => {
  Vue.component('AbModal', AbModal)
  Vue.prototype.$abModal = abModalFunc
}
